import { Props_HoverCardGridProps } from "./HoverCardGrid.props"
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

export const HoverCardGrid = (props: Props_HoverCardGridProps) => {
    return (
        <section className="attrax-hover-card-grid">
            <div className="attrax-hover-card-grid__container">
                {props.heading?.text?.value && (
                    <h2 className="attrax-hover-card-grid__heading">{props.heading.text.value}</h2>
                )}

                <div className="attrax-hover-card-grid__card-container">
                    {props.repeatable_card?.map((card, index) => (
                        <div
                            key={index}
                            className="attrax-hover-card-grid__card"
                        >
                            {card.backgroundImage?.value && (
                                <figure className='attrax-hover-card-grid__backgorund-container'>
                                    <img loading='lazy' height='280' width='314' src={card.backgroundImage.value} className="attrax-hover-card-grid__card-background" alt={card.imageAlt?.value ? card.imageAlt.value : ''}/>
                                </figure>
                            )}
                            
                            <div className="attrax-hover-card-grid__content">
                                {card.heading?.value && (
                                    <h3 className="attrax-hover-card-grid__card-heading">{card.heading.value}</h3>
                                )}
    
                                <div className='attrax-hover-card-grid__card-inner'>
                                    {card.content?.value && (
                                        <div className="attrax-hover-card-grid__card-text">
                                            {card.content?.value && Legacy_CompileMarkdown(card.content.value)}
                                        </div>
                                    )}

                                    {card.link?.value && (
                                        <a
                                            href={card.link.value}
                                            className="attrax-hover-card-grid__card-link"
                                        >
                                            {card.linkText?.value || 'Learn More'}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}